import XRegExp from "xregexp";
import {getItemByIndex, isArrayHaveItem} from "./listHelper";
import {getDescendantProp, isObject} from "./objectHelper";
import dayjs from "dayjs";
import {LocaleInfoModel} from "../core/components/localization/interface";
import {dateFormat, getFormatOptions} from "./dateHelpers";

export const isBlank = (str?: string | null) => {
    if (str === undefined || str === null) {
        return true;
    }
    return (/^\s*$/.test(str));
}
export const isNumeric = (str?: string) => {
   // return str !== undefined ? !isNaN(parseFloat(str)) : false;
    return str !== undefined ? /^[+-]?\d+(\.\d+)?$/.test(str) : false;

}
export const isCharNumeric = (charStr: string) => {
    return !!/\d/.test(charStr);
};
export const isUnicodeCharacter = (str: string) => {
    const regexUnicode = XRegExp.tag()`^\p{Letter}[\p{Letter}\p{Mark}]*$`;
    return regexUnicode.test(str); // -> true
}

export const reverseString = (str:string)=>{
    return str.split("").reverse().join("");
}
export const stringFormat = (str: string, formatValue: any[]| { [key: string]: any } = [],localeInfo?:LocaleInfoModel) => {

    let array:any[] = []
    let value = {};
    if(isArrayHaveItem(formatValue)){
        array = formatValue as any[];
    }else{
        if(isObject(formatValue)){
            value = formatValue;
        }
    }
    // const regex = /\{\w*\}/gm;
    const regex = /\{(\w*|(\w*:\w*))\}/gi;
    let m: RegExpExecArray | null;
    let result = str;
    while ((m = regex.exec(str)) !== null) {
        if (m.index === regex.lastIndex) {
            regex.lastIndex++;
        }


        //eslint-disable-next-line
        m.forEach((match) => {
            let tag = "";
            try{
                let format: undefined | string = undefined;
                if(match !== undefined){
                    if (match.indexOf(":") >= 0) {
                        const tempResult = match.replace("{", "").replace("}", "").split(":", 2);
                        tag = tempResult[0];
                        format = tempResult[1];
                    } else {
                        tag = match.replace("{", "").replace("}", "");
                    }
                    let newValue ="";
                    if (isNumeric(tag)) {
                        newValue = getItemByIndex(array, Number.parseInt(tag));
                    } else {
                        newValue = getDescendantProp(value, tag);
                    }
                    if (format === "date") {
                        const dateValue = dayjs(newValue, dateFormat.date)
                        newValue =dateValue.format(getFormatOptions("date",localeInfo).format)
                    } else if (format === "datetime") {
                        const dateValue =dayjs(newValue, dateFormat.dateTime)
                        newValue =dateValue.format(getFormatOptions("datetime",localeInfo).format)
                    }

                    if (newValue !== undefined) {
                        result = result.replace(match, newValue);
                    }
                }

            }
            catch(e){
                console.log(e)
            }


        });
    }
    return result;
}
export const isCapitalLetter = (str?: string) => isAnsiLetter(str, "CAPITAL");
export const isLowerLetter = (str?: string) => isAnsiLetter(str, "LOWER");
export const isAnsiLetter = (str?: string, check: "CAPITAL" | "LOWER" | "NONE" = "NONE"): boolean => {
    if (isBlank(str)) {
        return false;
    }
    if (str === undefined) {
        return false;
    }

    let i = 0;
    let character: any = '';
    while (i < str.length) {
        character = str.charAt(i);
        if (!isNaN(character * 1)) {
            return false;
        } else {
            if (!/^[a-zA-Z]$/.test(character)) {
                return false;
            }
            if (check !== "NONE") {
                if (character === character.toUpperCase()) {
                    if (check === "LOWER") {
                        return false;
                    }
                }
                if (character === character.toLowerCase()) {
                    if (check === "CAPITAL") {
                        return false;
                    }
                }
            }


        }
        i++;
    }
    return true;
}

export const convertTurkishCharacter =(name:string)=>{
    name.replace("ç", "c").replace("ş", "s").replace("ğ", "g").replace("ü", "u").
    replace("Ç", "C").replace("Ş", "S").replace("Ğ", "G").replace("Ü", "U");
}

export const convertUpperCaseFirstLetter =(word:string)=>{

    if(isBlank(word)){
        return word;
    }
    return  word.charAt(0).toUpperCase() + word.slice(1);
}
export const putASpaceBeforeCapitalLetter =(words:string)=>{
    if(isBlank(words)){
        return "";
    }
    const splitWords = words.split(/(?=[A-Z])/);

    let resulString = "";
    for (const word of splitWords) {
        if(isBlank(resulString)){

            resulString = convertUpperCaseFirstLetter(word);
        }else {
            resulString += " " + word;
        }
    }
    return  resulString;
}
const pushChunks = (word: string, limit: number, out: string[]) => {
    for (let i = 0; i < word.length; i += limit) out.push(word.slice(i, i + limit));
};
export const wrapLineSmart = (line: string, limit: number, out: string[]) => {
    const words = line.split(" ");
    let cur = "";

    for (const word of words) {
        if (word.length > limit) {
            if (cur) {
                out.push(cur.trim());
                cur = "";
            }
            pushChunks(word, limit, out);
            continue;
        }
        if (!cur) cur = word;
        else if ((cur + " " + word).length <= limit) cur += " " + word;
        else {
            out.push(cur.trim());
            cur = word;
        }
    }
    if (cur) out.push(cur.trim());
};
export const wrapText = (text: string, limit = 60): string[] => {
    const result: string[] = [];
    if (!text) return result;

    if (text.includes("\r\n")) {
        for (const line of text.split("\r\n")) {
            if (line.length > limit) wrapLineSmart(line, limit, result);
            else result.push(line);
        }
    } else {
        wrapLineSmart(text, limit, result);
    }
    return result;
};